/**
 * ForestHub Beispiel-Fälle
 * Zielgruppenspezifische Praxisbeispiele für den Schnell-Check.
 * Jede Zielgruppe bekommt ihre 5 häufigsten/typischsten Fälle.
 * Mehrsprachig via i18n (DE/EN/SE/PL/CZ).
 */

// ─── Waldbesitzer (Private Waldbesitzer) ───
export function getBeispielFaelle(t) {
  return [
    {
      id: 'wb-durchforstung',
      titel: t('fa.bspDurchforstungTitel'),
      kurz: t('fa.bspDurchforstungKurz'),
      freitext: t('fa.bspDurchforstungText'),
      tags: ['15 ha', 'Bayern', 'PEFC'],
      icon: 'trees',
    },
    {
      id: 'wb-kalamitaet',
      titel: t('fa.bspKalamitaetTitel'),
      kurz: t('fa.bspKalamitaetKurz'),
      freitext: t('fa.bspKalamitaetText'),
      tags: ['6 ha', 'Sachsen'],
      icon: 'bug',
    },
    {
      id: 'wb-aufforstung',
      titel: t('fa.bspAufforstungTitel'),
      kurz: t('fa.bspAufforstungKurz'),
      freitext: t('fa.bspAufforstungText'),
      tags: ['10 ha', 'Niedersachsen'],
      icon: 'seedling',
    },
    {
      id: 'wb-neophyten',
      titel: t('fa.bspNeophytenTitel'),
      kurz: t('fa.bspNeophytenKurz'),
      freitext: t('fa.bspNeophytenText'),
      tags: ['4 ha', 'Brandenburg'],
      icon: 'bug',
    },
    {
      id: 'wb-wildschaden',
      titel: t('fa.bspWildschadenTitel'),
      kurz: t('fa.bspWildschadenKurz'),
      freitext: t('fa.bspWildschadenText'),
      tags: ['3 ha', 'Rheinland-Pfalz'],
      icon: 'seedling',
    },
  ];
}

// Backward compat: static German fallback
export const BEISPIEL_FAELLE = [
  {
    id: 'wb-durchforstung',
    titel: 'Durchforstung planen',
    kurz: 'Dichter Fichtenbestand in Bayern soll professionell durchforstet werden.',
    freitext: 'Ich habe 15 Hektar Fichtenwald in Bayern, der dringend durchforstet werden muss. Der Bestand ist etwa 40 Jahre alt und sehr dicht. Ich brauche einen Dienstleister, der das professionell macht. PEFC-Zertifizierung ist wichtig.',
    tags: ['15 ha', 'Bayern', 'PEFC'],
    icon: 'trees',
  },
  {
    id: 'wb-kalamitaet',
    titel: 'Borkenkäfer-Befall',
    kurz: 'Akuter Käferbefall auf Fichtenbestand – schnelle Aufarbeitung nötig.',
    freitext: 'Borkenkäferbefall auf 6 ha Fichtenbestand in Sachsen. Sofortige Aufarbeitung nötig. Der Befall breitet sich aus und ich brauche dringend einen erfahrenen Dienstleister.',
    tags: ['6 ha', 'Sachsen'],
    icon: 'bug',
  },
  {
    id: 'wb-aufforstung',
    titel: 'Wiederaufforstung nach Sturm',
    kurz: 'Sturmfläche in Niedersachsen soll mit Douglasie und Buche bepflanzt werden.',
    freitext: 'Nach dem Sturm im Herbst muss eine Kahlfläche aufgeforstet werden. Etwa 10 Hektar in Niedersachsen. Geplant ist eine Mischung aus Douglasie und Buche. Ein Dienstleister soll die Pflanzung übernehmen.',
    tags: ['10 ha', 'Niedersachsen'],
    icon: 'seedling',
  },
  {
    id: 'wb-neophyten',
    titel: 'Traubenkirsche bekämpfen',
    kurz: 'Invasive Traubenkirsche verdrängt heimische Verjüngung im Mischwald.',
    freitext: 'In meinem 4 ha großen Mischwald in Brandenburg breitet sich die spätblühende Traubenkirsche massiv im Unterholz aus und verdrängt die heimische Naturverjüngung. Ich brauche professionelle Bekämpfung (Ringeln, Fällung mit Stockbehandlung) und einen Plan für die Nachkontrolle.',
    tags: ['4 ha', 'Brandenburg'],
    icon: 'bug',
  },
  {
    id: 'wb-wildschaden',
    titel: 'Wildverbiss stoppen',
    kurz: 'Junge Eichen und Buchen werden durch Rehwild stark verbissen.',
    freitext: 'Auf 3 ha Aufforstung in Rheinland-Pfalz werden meine jungen Eichen und Buchen massiv vom Rehwild verbissen. Trotz Jagd reicht der Schutz nicht. Ich brauche eine Empfehlung: Wuchshüllen, Drahthosen oder Zaun? Was ist bei meiner Fläche sinnvoll?',
    tags: ['3 ha', 'Rheinland-Pfalz'],
    icon: 'seedling',
  },
];

// ─── FBG / WBV (Forstbetriebsgemeinschaften) ───
export function getFbgBeispielFaelle(t) {
  return [
    {
      id: 'fbg-durchforstung-sammel',
      titel: t('fbg.bspSammelDurchforstungTitel'),
      kurz: t('fbg.bspSammelDurchforstungKurz'),
      freitext: t('fbg.bspSammelDurchforstungText'),
      tags: ['3 Mitglieder', 'Oberfranken'],
      icon: 'trees',
    },
    {
      id: 'fbg-harvester-sammel',
      titel: t('fbg.bspHarvesterTitel'),
      kurz: t('fbg.bspHarvesterKurz'),
      freitext: t('fbg.bspHarvesterText'),
      tags: ['3 Mitglieder', 'Harvester', 'Bayern'],
      icon: 'trees',
    },
    {
      id: 'fbg-foerderung-sammel',
      titel: t('fbg.bspFoerderungTitel'),
      kurz: t('fbg.bspFoerderungKurz'),
      freitext: t('fbg.bspFoerderungText'),
      tags: ['3 Mitglieder', 'Thüringen'],
      icon: 'file',
    },
    {
      id: 'fbg-kalamitaet-sammel',
      titel: t('fbg.bspSammelKalamitaetTitel'),
      kurz: t('fbg.bspSammelKalamitaetKurz'),
      freitext: t('fbg.bspSammelKalamitaetText'),
      tags: ['2 Mitglieder', 'Sachsen'],
      icon: 'bug',
    },
    {
      id: 'fbg-holzvermarktung',
      titel: t('fbg.bspHolzvermarktungTitel'),
      kurz: t('fbg.bspHolzvermarktungKurz'),
      freitext: t('fbg.bspHolzvermarktungText'),
      tags: ['5 Mitglieder', 'Niedersachsen'],
      icon: 'compass',
    },
  ];
}

// ─── Berater (Forstliche Sachverständige / Berater) ───
export function getBeraterBeispielFaelle(t) {
  return [
    {
      id: 'ber-forsteinrichtung',
      titel: t('berater.bspForsteinrichtungTitel'),
      kurz: t('berater.bspForsteinrichtungKurz'),
      freitext: t('berater.bspForsteinrichtungText'),
      tags: ['120 ha', 'Hessen'],
      icon: 'file',
    },
    {
      id: 'ber-waldwertgutachten',
      titel: t('berater.bspWaldwertTitel'),
      kurz: t('berater.bspWaldwertKurz'),
      freitext: t('berater.bspWaldwertText'),
      tags: ['25 ha', 'Bayern', 'Erbschaft'],
      icon: 'compass',
    },
    {
      id: 'ber-foerdermittel',
      titel: t('berater.bspFoerdermittelTitel'),
      kurz: t('berater.bspFoerdermittelKurz'),
      freitext: t('berater.bspFoerdermittelText'),
      tags: ['18 ha', 'NRW', 'Waldumbau'],
      icon: 'file',
    },
    {
      id: 'ber-wildschaden',
      titel: t('berater.bspWildschadenTitel'),
      kurz: t('berater.bspWildschadenKurz'),
      freitext: t('berater.bspWildschadenText'),
      tags: ['Gutachten', 'Baden-Württemberg'],
      icon: 'bug',
    },
    {
      id: 'ber-naturschutz',
      titel: t('berater.bspNaturschutzTitel'),
      kurz: t('berater.bspNaturschutzKurz'),
      freitext: t('berater.bspNaturschutzText'),
      tags: ['FFH-Gebiet', '40 ha', 'Thüringen'],
      icon: 'seedling',
    },
  ];
}

// ─── Kommune (Städte und Gemeinden) ───
export function getKommuneBeispielFaelle(t) {
  return [
    {
      id: 'kom-verkehrssicherung',
      titel: t('kommune.bspVerkehrssicherungTitel'),
      kurz: t('kommune.bspVerkehrssicherungKurz'),
      freitext: t('kommune.bspVerkehrssicherungText'),
      tags: ['Kreisstraße', '2 km'],
      icon: 'trees',
    },
    {
      id: 'kom-stadtwald',
      titel: t('kommune.bspStadtwaldTitel'),
      kurz: t('kommune.bspStadtwaldKurz'),
      freitext: t('kommune.bspStadtwaldText'),
      tags: ['80 ha', 'Stadtwald'],
      icon: 'compass',
    },
    {
      id: 'kom-spielplatz',
      titel: t('kommune.bspSpielplatzTitel'),
      kurz: t('kommune.bspSpielplatzKurz'),
      freitext: t('kommune.bspSpielplatzText'),
      tags: ['Waldkindergarten', 'Sicherheit'],
      icon: 'seedling',
    },
    {
      id: 'kom-sturmschaden',
      titel: t('kommune.bspSturmschadenTitel'),
      kurz: t('kommune.bspSturmschadenKurz'),
      freitext: t('kommune.bspSturmschadenText'),
      tags: ['15 ha', 'Kommunalwald'],
      icon: 'bug',
    },
    {
      id: 'kom-erholungswald',
      titel: t('kommune.bspErholungswaldTitel'),
      kurz: t('kommune.bspErholungswaldKurz'),
      freitext: t('kommune.bspErholungswaldText'),
      tags: ['Naherholung', '25 ha'],
      icon: 'compass',
    },
  ];
}

// ─── Unsicher (Neue Waldbesitzer, Erben, Orientierung) ───
export function getUnsicherBeispielFaelle(t) {
  return [
    {
      id: 'uns-geerbt',
      titel: t('unsicher.bspGeerbtTitel'),
      kurz: t('unsicher.bspGeerbtKurz'),
      freitext: t('unsicher.bspGeerbtText'),
      tags: ['8 ha', 'Thüringen'],
      icon: 'compass',
    },
    {
      id: 'uns-zustand',
      titel: t('unsicher.bspZustandTitel'),
      kurz: t('unsicher.bspZustandKurz'),
      freitext: t('unsicher.bspZustandText'),
      tags: ['5 ha', 'Mischwald'],
      icon: 'trees',
    },
    {
      id: 'uns-was-waechst',
      titel: t('unsicher.bspWasWaechstTitel'),
      kurz: t('unsicher.bspWasWaechstKurz'),
      freitext: t('unsicher.bspWasWaechstText'),
      tags: ['3 ha', 'Sachsen-Anhalt'],
      icon: 'seedling',
    },
    {
      id: 'uns-wert',
      titel: t('unsicher.bspWertTitel'),
      kurz: t('unsicher.bspWertKurz'),
      freitext: t('unsicher.bspWertText'),
      tags: ['12 ha', 'Hessen'],
      icon: 'file',
    },
    {
      id: 'uns-grenzen',
      titel: t('unsicher.bspGrenzenTitel'),
      kurz: t('unsicher.bspGrenzenKurz'),
      freitext: t('unsicher.bspGrenzenText'),
      tags: ['Parzelle', 'Grenzen unklar'],
      icon: 'compass',
    },
  ];
}
